<template>
  <div class="wrapper">
    <section class="promo">
      <div class="container">
        <div class="row">
          <transition enter-active-class="bounceInLeft" name="bounce">
            <div class="col-12 promo__conten" v-if="display">
              <h1 v-html="$t('landing.appForm.title')"></h1>
              <p v-html="$t('landing.appForm.desc')"></p>
              <div class="promo__btns-wrap">
                <a :href="appFormDownloadLink" target="_blank" class="btn btn--big btn--blue">{{$t('landing.appForm.downloadBtn')}}</a>
              </div>
              <div class="about__animated-content">
                <p>{{$t('landing.appForm.about.1')}}</p>
                <p>{{$t('landing.appForm.about.2')}}</p>
              </div>
              <div class="about__animated-content mt-100">
                <h3 class="color-blue">{{$t('landing.appForm.tip.title')}}</h3>
                <ul>
                  <li>{{$t('landing.appForm.tip.1')}}</li>
                  <li>{{$t('landing.appForm.tip.2')}}</li>
                  <li>{{$t('landing.appForm.tip.3')}}</li>
                  <li>{{$t('landing.appForm.tip.4')}}</li>
                  <li>{{$t('landing.appForm.tip.5')}}</li>
                </ul>
              </div>
            </div>
          </transition>
        </div>
        <transition enter-active-class="animated bounceInLeft" name="bounce">
          <div v-if="display2">
            <img src="./img/g-icon.png" data-aos="fade-up" alt="" class="vert-move">
            <img src="./img/promo-bg.png" data-aos="fade-up" alt="" class="promo__img">
          </div>
        </transition>
      </div>
    </section>
    <img src="./img/services-bg-1.png" class="services__cosmos" alt="">
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { getterTypes } from '@/store/getter-types';
  export default {
    name: "applicationForm",
    data() {
      return {
        appFormDownloadLink: '',
        display: false,
        display2: false,
      }
    },
    computed: {
      ...mapGetters([getterTypes.Getter_Lang]),
    },
    mounted() {
      this.appFormDownloadLink = window.env.appFormDownloadLinkEn;
      if (this.Getter_Lang.code !== 'en_US') {
        this.appFormDownloadLink = window.env.appFormDownloadLinkOther;
      }
      this.display = true;
      this.display2 = true;
    }
  }
</script>

<style lang="stylus" scoped>
  @import "applicationForm.scoped.styl";
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>
<style lang="css" scoped>
  .color-blue {
    color: #00cde4;
  }
  h1 {
    font-size: 47px;
    line-height: 50px;
    margin-bottom: 40px;
}
</style>
